<template>
  <div v-if="events.length > 0">
    <div
      v-for="(event) in events"
      :key="event.id"
      class="vertical-event"
    >
      <div class="event_archive__img-box">
        <a :href="event.link">
          <div class="event_archive__content">
            <div class="event_archive__img-box__img">
              <img
                :src="event.main_image"
                class="event_archive__img-box__img-fill"
              />
              <div class="event_archive__img-box__avatar">
                <img
                  :src="event.user_avatar"
                  class="p-avatar--vsm p-avatar--circle"
                />
              </div>
            </div>
            <div class="event_archive__info">
              <div class="event_archive__img-box__title">
                <h3
                  class="p-txt-vsmall p-txt-bold event_archive__img-box__title--clamp"
                >
                  {{ event.title }}
                </h3>
              </div>
              <div class="event_archive__schedule">
                <div class="p-txt-tiny p-txt-light">{{ event.event_date }}</div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerticalEventList',
  props: {
    events: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss">
.vertical-event {
  width: 100%;
  object-position: left;
  padding-bottom: 20px;
  position: relative;
}
</style>
